import { isLanguage, languageCookie, languageFromCookie, preferredLanguage, type Language } from "../shared/languages";

export { translate, type TranslationKey } from "../shared/translations";
export { localeFor, directionFor, languages, languageNames, type Language } from "../shared/languages";

export function detectLanguage(): Language {
  const query = new URLSearchParams(window.location.search).get("lang");
  if (isLanguage(query)) return query;
  const cookie = languageFromCookie(document.cookie);
  if (cookie) return cookie;
  try {
    const saved = localStorage.getItem("agentbuck:language:preference");
    if (isLanguage(saved)) return saved;
  } catch {
    // Browser language detection also works when storage is unavailable.
  }
  return preferredLanguage(navigator.languages?.length ? navigator.languages : [navigator.language]);
}

export function saveLanguage(language: Language) {
  try {
    localStorage.setItem("agentbuck:language:preference", language);
  } catch {
    // The cookie still preserves explicit choices when local storage is blocked.
  }
  document.cookie = `${languageCookie}=${language}; Path=/; Max-Age=31536000; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}`;
}
